import { ICustomButton } from "../interfaces/custom-button.interface"

export const CustomButton = ({ hasIcon, text, icon, btnType, btnSeverity, hasText, className, style, onClick }: ICustomButton) => {
    return (
        <button onClick={onClick} style={style ? style : {}} className={`btn btn-${btnType}-${btnSeverity} ${className ? className : ''} `}>
            {hasIcon && icon} {hasIcon ? '  ' : ''} {hasText && text}
        </button>
    )
}